export const updateCeoStatus = (ceoStatus) => {
    return {
        type: "UPDATECEOSTATUS",
        payload: ceoStatus,
    };
};